import axiosInstance from './axiosInstance'; 

const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';



export const templatesList = async (status, token,page,size) => {
  try {
    const response = await axiosInstance.get(`templates/templatesList/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};

export const templatesListFront = async (status, token,page,size) => {
  try {
    const response = await axiosInstance.get(`publishers/front/templatesList/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};

export const templatesMenuList = async (status, token,page,size) => {
  try {
    const response = await axiosInstance.get(`templates/templatesMenuList/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};

export const templateupdateStatus = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`templates/updateStatus/${id}/${status}`, {
      //params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("templatetypeandattributeupdateStatus", error);
    throw error;
  }
};

export const templateDetail = async (id,status, token) => {
  try {
    const response = await axiosInstance.get(`templates/templateDetail/${id}/${status}`, {
      //params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};

export const templatetypelist = async (status, token,page,size) => {
  try {
    const response = await axiosInstance.get(`templatetypes/templatetypesList/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};

export const attrtypeList = async ( lang,token) => {
  try {
    const response = await axiosInstance.get(`attributes/attrtypeList/${lang}`, {
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};



export const templatesandattributedataList = async (id,status, token) => {
  try {
    const response = await axiosInstance.get(`templatesandattributedata/templatesandattributedataList/${id}/${status}`, {
      //params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};


export const templatetypeandattributeTemplateidList = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`templatetypeandattribute/templatetypeandattributeTemplateidList/${id}/${status}`, {
      //params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};


export const templatetypeandattributeupdateStatus = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`templatetypeandattribute/updateStatus/${id}/${status}`, {
      //params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("templatetypeandattributeupdateStatus", error);
    throw error;
  }
};

export const templatetypeandattributeCreate = async (data, token) => {
  try {
    const response = await axiosInstance.post(`templatetypeandattribute/create`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("Error templatesCreate:", error);
    throw error;
  }
};

export const templatesCreate = async (data, token) => {
  try {
    const response = await axiosInstance.post(`templates/create`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("Error templatesCreate:", error);
    throw error;
  }
};

export const templatesandattributedataCreate = async (templateid, data, token) => {
  try {
    const response = await axiosInstance.post(`templatesandattributedata/create/${templateid}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("Error templatesandattributedataCreate:", error);
    throw error;
  }
};

export const createTemplateType = async (data, token) => {
  const response = await axiosInstance.post(`templatetypes/create`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


export const templatetypesDetail = async (templateid,status, token) => {
  const response = await axiosInstance.get(`templatetypes/templatetypesDetail/${templateid}/${status}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateTemplateType = async (id,status,data, token) => {
  const response = await axiosInstance.post(`templatetypes/update/${id}/${status}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


export const attributesdataUpdate = async (templateid,attributesid,status,data, token) => {
  const response = await axiosInstance.post(`attributesdata/update/${templateid}/${attributesid}/${status}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const templatesandattributedataUpdate = async (templateid,attrid,status, token) => {
  const response = await axiosInstance.get(`templatesandattributedata/updateStatus/${templateid}/${attrid}/${status}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};



export const attributesList = async (status, token,page,size) => {
  try {
    const response = await axiosInstance.get(`attributes/attributesList/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};


export const createAttribute = async (data, token) => {
  const response = await axiosInstance.post(`attributes/create`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


export const attributeDetail = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`attributes/attributeDetail/${id}/${status}`, {
      //params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`,
    }
    
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};



export const attributesUpdate = async (attributesid,status,data, token) => {
  const response = await axiosInstance.post(`attributes/update/${attributesid}/${status}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const attributeStatusUpdate = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`attributes/updateStatus/${id}/${status}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      
    });
    return response.data;
  } catch (error) {
    console.error("Error attributeStatusUpdate :", error);
    throw error;
  }
};

export const templatetypesStatusUpdate = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`templatetypes/updateStatus/${id}/${status}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      
    });
    return response.data;
  } catch (error) {
    console.error("Error templatetypesUpdate :", error);
    throw error;
  }
};

export const templatesUpdateName = async (templateid,status,data, token) => {
  const response = await axiosInstance.post(`templates/updateName/${templateid}/${status}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};